module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC07_ua.32524e79.webp";